import { formatTournamentDate } from '../utils/tournamentTime';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';

import { getAccessToken, clearAuthStorage } from '../services/api';
import Loading from '../components/Loading';
export default function Tournaments() {
  const [tournaments, setTournaments] = useState([]);
  const [myTournaments, setMyTournaments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [error, setError] = useState(null);
  const isLoggedIn = !!getAccessToken();
  const navigate = useNavigate();

  useEffect(() => {
    loadTournaments();
  }, [filter]);

  const loadTournaments = async () => {
    setLoading(true);
    setError(null);
    try {
      const params = {};
      if (filter !== 'all') params.status = filter;
      const res = await api.tournaments.getAll(params);
      setTournaments((res.data.data || res.data.tournaments || []).filter(t => t.game_type === 'whot'));

      if (isLoggedIn) {
        try {
          const myRes = await api.tournaments.getMyTournaments();
          setMyTournaments(myRes.data.data || []);
        } catch (e) {
          // Ignore if not logged in properly
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load tournaments');
    } finally {
      setLoading(false);
    }
  };

  const handleJoin = async (tournamentId) => {
    if (!isLoggedIn) {
      navigate('/login');
      return;
    }
    try {
      await api.tournaments.join(tournamentId);
      loadTournaments();
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to join tournament');
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      scheduled: '#f59e0b',
      live: '#10b981',
      closed: '#6b7280',
      completed: '#3b82f6',
      cancelled: '#ef4444',
    };
    return colors[status] || '#aaa';
  };

  const getGameIcon = () => '🃏';
  const getGameName = () => 'Whot';

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
        <div>
          <Link to="/dashboard" style={{ color: '#888', textDecoration: 'none', fontSize: '14px' }}>
            ← Back to Dashboard
          </Link>
          <h1 style={{ margin: '10px 0 0' }}>🏆 Tournaments</h1>
        </div>
        <Link
          to="/tournaments/how-to-play"
          style={{
            background: '#2a2a3e',
            color: '#fff',
            padding: '10px 16px',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: 'bold',
            border: '1px solid #3b3b55',
          }}
        >
          📖 How to Play
        </Link>
        {isLoggedIn && (
          <Link
            to="/tournaments/my"
            style={{
              background: '#1a1a2e',
              color: '#00d4aa',
              padding: '10px 20px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: 'bold',
              border: '1px solid #00d4aa33',
            }}
          >
            My Tournaments ({myTournaments.length})
          </Link>
        )}
      </div>

      {/* Filter Tabs */}
      <div style={{ display: 'flex', gap: '10px', margin: '20px 0', flexWrap: 'wrap' }}>
        {['all', 'scheduled', 'live', 'completed'].map(f => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            style={{
              padding: '8px 16px',
              borderRadius: '20px',
              border: '1px solid #333',
              background: filter === f ? '#00d4aa' : 'transparent',
              color: filter === f ? '#000' : '#aaa',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: filter === f ? 'bold' : 'normal',
            }}
          >
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      {error && (
        <div style={{ background: '#3b1111', color: '#ef4444', padding: '12px', borderRadius: '8px', marginBottom: '16px' }}>
          {error}
        </div>
      )}

      {loading ? (
        <Loading variant="section" label="" />
      ) : tournaments.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
          <p style={{ fontSize: '48px', margin: '0' }}>🏆</p>
          <p>No tournaments found.</p>
          {isLoggedIn && (
            <p style={{ fontSize: '14px' }}>Check back later or ask an admin to create one!</p>
          )}
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {tournaments.map(t => {
            const myT = myTournaments.find(mt => mt.id === t.id);
            const isJoined = Boolean(myT);
            const playsRemaining = myT?.playsRemaining !== undefined
              ? Number(myT.playsRemaining)
              : (isJoined ? Math.max(0, Number(t.max_plays_per_player || 50) - Number(myT.plays_used || 0)) : null);
            const canJoin = ['scheduled', 'live'].includes(t.status) &&
              !isJoined &&
              Number(t.current_players || 0) < Number(t.max_players || 0);
            const canPlay = isJoined && t.status === 'live' && playsRemaining > 0;
            const entryFee = parseFloat(t.entry_fee || 0);
            const rankRewards = Array.isArray(t.rank_rewards) ? t.rank_rewards : [];
            const firstPrize = Number(rankRewards.find(r => Number(r.rank) === 1)?.amount || 0);
            const displayedPlayers = Number(t.current_players || 0);

            return (
              <div
                key={t.id}
                style={{
                  background: '#1a1a2e',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid #2a2a3e',
                  transition: 'border-color 0.2s',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ fontSize: '24px' }}>{getGameIcon(t.game_type)}</span>
                      <div>
                        <h3 style={{ margin: 0, fontSize: '18px' }}>{t.name}</h3>
                        <span style={{ color: '#888', fontSize: '13px' }}>
                          {getGameName(t.game_type)} • {t.max_plays_per_player} plays/player
                        </span>
                      </div>
                    </div>
                    <div style={{ marginTop: '12px', display: 'flex', gap: '16px', flexWrap: 'wrap', fontSize: '14px' }}>
                      <span>💰 Entry: <strong>₦{entryFee.toLocaleString()}</strong></span>
                      <span>👥 Players: <strong>{displayedPlayers}/{t.max_players}</strong></span>
                      <span style={{ color: getStatusColor(t.status) }}>
                        ● {t.status.charAt(0).toUpperCase() + t.status.slice(1)}
                      </span>
                    </div>
                    <div style={{ marginTop: '8px', fontSize: '13px', color: '#666' }}>
                      {formatTournamentDate(t.start_time)} — {formatTournamentDate(t.end_time)}
                    </div>
                    {firstPrize > 0 ? (
                      <div style={{ marginTop: '8px', fontSize: '13px' }}>
                        🏆 First Prize Pool: <strong style={{ color: '#f59e0b' }}>₦{firstPrize.toLocaleString()}</strong>
                      </div>
                    ) : null}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-end' }}>
                    <Link
                      to={`/tournaments/${t.id}`}
                      style={{
                        padding: '8px 16px',
                        background: '#2a2a3e',
                        color: '#aaa',
                        borderRadius: '8px',
                        textDecoration: 'none',
                        fontSize: '14px',
                        textAlign: 'center',
                      }}
                    >
                      View Details
                    </Link>
                    {canJoin && (
                      <button
                        onClick={() => handleJoin(t.id)}
                        style={{
                          padding: '8px 16px',
                          background: '#00d4aa',
                          color: '#000',
                          borderRadius: '8px',
                          border: 'none',
                          cursor: 'pointer',
                          fontSize: '14px',
                          fontWeight: 'bold',
                        }}
                      >
                        Join (₦{entryFee.toLocaleString()})
                      </button>
                    )}
                    {canPlay && (
                      <Link
                        to={`/tournaments/${t.id}/play`}
                        style={{
                          padding: '8px 16px',
                          background: '#f59e0b',
                          color: '#000',
                          borderRadius: '8px',
                          textDecoration: 'none',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        ▶ Play (₦{entryFee.toLocaleString()})
                      </Link>
                    )}
                    {isJoined && t.status === 'live' && playsRemaining === 0 && (
                      <button type="button" onClick={() => window.alert(`🏆 Tournament Plays Completed\n\nYou've used all ${t.max_plays_per_player} of your ${t.max_plays_per_player} available plays for this tournament.\n\nYour results have been recorded on the leaderboard.`)}
                        style={{ padding: '8px 16px', background: '#2a2a3e', color: '#aaa', borderRadius: '8px', border: '1px solid #444', cursor: 'default', fontSize: '14px', fontWeight: 'bold' }}>
                        🔒 Play Limit Reached
                      </button>
                    )}
                    {isJoined && t.status === 'live' && playsRemaining === 1 && (
                      <span style={{ color: '#f59e0b', fontSize: '12px', fontWeight: '700' }}>
                        1 play remaining · {Number(t.max_plays_per_player) - 1} of {t.max_plays_per_player} plays used
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
